import { Button } from "reactstrap";
import "./styles.css";

export function ContentCardBanner({
  image,
  fallbackColor = "dark",
  fallbackIcon = "graduation-cap",
  actions = [],
  badge = false
}) {
  return (
    <div className="banner-container-responsive position-relative">
      {actions.length > 0 && (
        <div className="bannerOverlay h-100">
          {actions?.map(action => (
            <Button
              color="light"
              className="w-100 d-flex align-items-center justify-content-center p-1 mb-1"
              key={action.title}
              onClick={e => {
                e.preventDefault();
                action.action();
              }}
            >
              {typeof action.icon === "string" ? (
                <i className={`contentIcon fa fa-${action.icon}`}></i>
              ) : (
                action.icon
              )}
              <small className="ml-1" style={{ fontSize: "10px" }}>
                {action.title}
              </small>
            </Button>
          ))}
        </div>
      )}

      {badge && (
        <span
          className="badge badge-success position-absolute mt-1 ml-1 p-1"
          style={{ zIndex: 2, fontSize: "9px" }}
        >
          {badge}
        </span>
      )}

      {image ? (
        <img
          src={image}
          className="h-100 w-100"
          style={{ objectFit: "scale-down", padding: "10px" }}
          alt="Banner"
        />
      ) : (
        <div
          className={`w-100 h-100 bg-${fallbackColor} d-flex align-items-center justify-content-center`}
        >
          <i className={`fa fa-${fallbackIcon} text-white`}></i>
        </div>
      )}
    </div>
  );
}
